import React, { Fragment, useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { AppBar, Button, Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import UndoIcon from '@mui/icons-material/Undo';

import { Bill } from './Bill';
import useFetch from '../../hooks/useFetch';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PrintIcon from '@mui/icons-material/Print';
import { useLocation, useNavigate } from 'react-router-dom';
import { urlGetEstimateById } from '../../helpers/urls';
import './style.css'


export const PrintPDF = () => {

  const location = useLocation();
  const componentRef = useRef();
  const { data, loading } = useFetch(`${urlGetEstimateById}${location.search}`, 'GET');

  const possibleStatus = ['Provisional', 'Aceptado', 'Definitivo'];
    const navigate = useNavigate();

    const handleClick = () => {
        if (possibleStatus.includes(data[0]?.status)) {
            navigate('/estimate')
        } else {
            navigate('/certification')
        }
    }

  return (
    <Stack alignItems='center'>
      {(!loading && data?.length > 0) ?
        <Fragment>
          < Bill ref={componentRef} formValues={data[0]} client={[data[0].client]} />
          <AppBar >
            <div className='appBar'>
              <Button sx={{ display: 'flex', flexDirection: 'column' }} color='inherit' variant='text' onClick={handleClick}><UndoIcon />Volver</Button>
              <ReactToPrint
                trigger={() =>

                  <Button color='inherit' variant='text'> <FileDownloadIcon /> <PrintIcon /> </Button>
                }
                content={() => componentRef.current}
              />
            </div>
          </AppBar>
        </Fragment>
        : <CircularProgress sx={{ marginTop: '5rem' }} />}
    </Stack>
  );
};